<div class="mb-3" align="end">
	<button mat-raised-button color="primary" (click)="openDialog()">Dodaj masowe płatności</button>
</div>
